import React from 'react';
import EditorChrome from './EditorChrome';

const downloadPath = '/Downloads/PodBox-0.1.0-macOS-universal.zip';

const PodBox = () => (
    <main className="container portfolio-shell inner-shell">
        <EditorChrome active="/PodBox" />
        <article className="inner-editor podbox-page">
            <a className="back-link" href="/">Back to homepage</a>

            <header className="podbox-hero">
                <div className="podbox-intro">
                    <p className="eyebrow"><span className="syntax-comment">;;</span> A standalone iPod manager for macOS</p>
                    <h1>PodBox</h1>
                    <p className="podbox-lede">
                        Put music on a classic iPod without syncing your entire library or using iTunes.
                        PodBox lets you browse your device, drag songs on, remove songs, build playlists,
                        edit metadata, and play tracks through your Mac.
                    </p>
                    <div className="podbox-actions">
                        <a className="btn podbox-download" href={downloadPath} download>
                            Download for Mac
                        </a>
                        <a className="podbox-source" href="https://github.com/MilanMarocchi/podbox" target="_blank" rel="noreferrer">
                            View source on GitHub ↗
                        </a>
                    </div>
                    <p className="podbox-build-note">Version 0.1.0 preview · macOS 11 or newer · Apple silicon and Intel</p>
                </div>

                <aside className="podbox-status" aria-label="PodBox release information">
                    <span>Release</span>
                    <strong>Mac preview</strong>
                    <p>Free and open source.</p>
                </aside>
            </header>

            <figure className="podbox-screenshot">
                <img
                    src="/PodBox/screenshot.png"
                    alt="PodBox showing a classic iPod music library, playlists, track browser, and device capacity"
                />
                <figcaption>Browse, search, organise, and play the music on your iPod.</figcaption>
            </figure>

            <section className="podbox-section" aria-labelledby="what-podbox-does">
                <div className="section-heading">
                    <h2 id="what-podbox-does">What PodBox does</h2>
                    <p>A focused, manual alternative to all-or-nothing library sync.</p>
                </div>
                <div className="podbox-feature-grid">
                    <article>
                        <span>01</span>
                        <h3>Manage your iPod directly</h3>
                        <p>Browse and search tracks, drag music onto the device, remove songs, edit tags, manage playlists, and safely eject when you are done.</p>
                    </article>
                    <article>
                        <span>02</span>
                        <h3>Keep your Mac library yours</h3>
                        <p>Index folders in place without moving or changing your files, or copy music out of Apple Music into a library PodBox can manage.</p>
                    </article>
                    <article>
                        <span>03</span>
                        <h3>Built for classic iPods</h3>
                        <p>PodBox reads classic-line iPods directly and includes guarded write support across generations, with checks before making device changes.</p>
                    </article>
                </div>
            </section>

            <section className="podbox-install" aria-labelledby="install-podbox">
                <div>
                    <p>Getting started</p>
                    <h2 id="install-podbox">Download, unzip, and open PodBox.</h2>
                    <span>
                        This preview build is unsigned. On first launch, Control-click PodBox, choose <strong>Open</strong>,
                        then confirm. macOS may also ask for access to your iPod and music folders.
                    </span>
                </div>
                <a className="btn podbox-download" href={downloadPath} download>Download PodBox 0.1.0</a>
            </section>

            <section className="podbox-feedback" aria-labelledby="podbox-feedback">
                <p>Found a bug?</p>
                <h2 id="podbox-feedback">Tell me what happened.</h2>
                <span>If something is not working, email me and include your Mac model, macOS version, iPod model, and what you were trying to do.</span>
                <a href="mailto:milan@marcellovalentino.com?subject=PodBox%20bug%20report">milan@marcellovalentino.com ↗</a>
            </section>
        </article>
    </main>
);

export default PodBox;
